import React, { Component } from "react";
import history from "custom-history";
import PaymentLayout from "home/components/payment-layout";
import { apiFetch } from "apiFetch";
import { toast } from "react-toastify";

const errorMessage = "An error occured, please try again.";

class Payment extends Component {

  state = {
    selectedAmount: { type: null },
    selectedPaymentMethod: { id: null },
    emptyStepOption: true,
    step: 1,
    paymentInProgress: false
  }

  submitPayment = paymentParams => {
    const url = `/plans/${this.props.currentPlan.paymentId}/payments`;

    apiFetch("/api" + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(paymentParams)
    })
      .then(data => {
        history.push(`${url}/${data.confirmationId}`);
        this.props.handleShow("Payment", false);
        this.props.handleShow("PaymentInformation", true, {
          confirmation: {
            id: data.confirmationId,
            amount: paymentParams.amount,
            paymentMethod: this.state.selectedPaymentMethod,
            date: data.transactionDate
          }
        });
      })
      .catch((e) => {
        if (e !== 'Unauthorized') {
          toast.error(errorMessage);
        }
      })
  };

  setPaymentAmount = plan => {
    if (plan.type === "other")
      plan.value = document.getElementById("customValue").value;

    this.setState({
      selectedAmount: plan,
      emptyStepOption: false
    });
  };

  setPaymentMethod = method => {
    this.setState({
      selectedPaymentMethod: method,
      emptyStepOption: false
    });
  };

  addPaymentMethod = paymentMethod => {
    this.props.paymentMethods.push(paymentMethod);
  };

  handleStep = stepAmount => {
    this.setState({
      step: this.state.step + stepAmount,
      emptyStepOption: true
    });
  };

  validAmount = (paymentParams, currentPlan) => {
    const totalDueAmount = currentPlan.totalDueAmount;

    if (parseFloat(paymentParams.amount) > parseFloat(totalDueAmount)) {
      toast.error(
        "The payment amount cannot be more than the remaining balance"
      );
      return false;
    }

    if (parseFloat(paymentParams.amount) === 0) {
      toast.error("The payment amount should be more than zero.");
      return false;
    }

    return true;
  };

  confirmPayment = (event, currentPlan) => {
    this.setState({
      paymentInProgress: true
    });

    var paymentParams = {
      id: this.state.selectedPaymentMethod.id,
      amount: this.state.selectedAmount.value.toString()
    };

    if (this.validAmount(paymentParams, currentPlan)) {
      this.submitPayment(paymentParams);
    } else {
      this.setState({
        paymentInProgress: false
      });
    }
  };

  render() {
    var stepOneParams = {
      selectedAmount: this.state.selectedAmount,
      setPaymentAmount: this.setPaymentAmount,
      currentPlan: this.props.currentPlan,
      emptyStepOption: this.state.emptyStepOption
    };

    var stepTwoParams = {
      paymentMethods: this.props.paymentMethods,
      selectedPaymentMethod: this.state.selectedPaymentMethod,
      setPaymentMethod: this.setPaymentMethod,
        addPaymentMethod: this.addPaymentMethod,
      emptyStepOption: this.state.emptyStepOption,
      currentPlan: this.props.currentPlan,
      component: "MakePayment",
      handleShow: this.props.handleShow
    };

    var stepThreeParams = {
      selectedAmount: this.state.selectedAmount,
      selectedPaymentMethod: this.state.selectedPaymentMethod,
      currentPlan: this.props.currentPlan
    };

    return (
      <PaymentLayout
        {...this.state}
        show={this.props.show || true}
        currentPlan={this.props.currentPlan}
        confirmPayment={this.confirmPayment}
        handleShow={this.props.handleShow}
        handleStep={this.handleStep}
        stepOneParams={stepOneParams}
        stepTwoParams={stepTwoParams}
        stepThreeParams={stepThreeParams}
      />
    );
  }
}

export default Payment;



// WEBPACK FOOTER //
// ./src/home/containers/payment.js